import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//constants
import { getProvinces } from 'api/company';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input/index.js';

const FiltersTableDeliveries = ({ 
  formFilter, 
  setFormFilter, 
  handleClear, 
  t, 
  page, 
  setPage 
}) => {
  const [provinces, setProvinces] = useState([]);

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  const fetchProvinces = async () => {
    const { status, data } = await getProvinces();
    if (status === 200) {
      const customProvinces = data.map((prov) => {
        return prov.nombre !== '' ? {
          id: prov.id,
          value: prov.nombre
        } : null;
      }).filter(prov => prov !== null);
      setProvinces(customProvinces);
    }
  }

  useEffect(() => {
    fetchProvinces();
  }, [])

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('postalcode')}
          value={formFilter.postal_codes}
          label={t('postalcode')}
          onChange={(e) => handleSearch(e, 'postal_codes')}
        />
        <SelectInputCustom
          choices={provinces}
          label={t('province')}
          placeholder={t('select')}
          onCheckedItem={(e) => handleSearch(e, 'province')}
          value={formFilter.province}
          className="d-flex align-items-center"
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableDeliveries.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableDeliveries;
